// DeferredBaselineNudge — Phase 3 #15 nudge for users who chose "Just
// log for now" at the onboarding branch and have logged at least one
// dose. Dismissible per-day; re-surfaces tomorrow or once the user has
// logged 5 doses.
//
// Extracted 2026-05-26 from TodayScreen.tsx (lines 1020-1043). The
// visibility predicate (deferredMode && showDeferredNudge) stays in
// TodayScreen — this component is the pure JSX + the two button
// callbacks. Receives the callbacks as props so the parent owns the
// dismiss state (localStorage write + render-forcing tick increment)
// and the route navigation.

import { Button } from '../ui/Button';
import { Card } from '../ui/Card';

interface DeferredBaselineNudgeProps {
  /** Fired when the user taps "Later" — parent dismisses for today + bumps the re-render tick. */
  onDismiss: () => void;
  /** Fired when the user taps "Set up my plan →" — parent navigates to /app/onboarding. */
  onSetUpPlan: () => void;
}

export function DeferredBaselineNudge({ onDismiss, onSetUpPlan }: DeferredBaselineNudgeProps) {
  return (
    <Card accentLeft>
      <h3 className="text-h3" style={{ marginBlockEnd: 'var(--space-2)' }}>
        Nice. Want to set your real numbers now?
      </h3>
      <p className="muted" style={{ marginBlockEnd: 'var(--space-3)' }}>
        It takes ~90 seconds and unlocks the streak + milestones.
      </p>
      <div className="row" style={{ justifyContent: 'space-between' }}>
        <Button variant="tertiary" onClick={onDismiss}>
          Later
        </Button>
        <Button size="md" onClick={onSetUpPlan}>
          Set up my plan →
        </Button>
      </div>
    </Card>
  );
}
